import { useQuery, useMutation, useQueryClient } from "react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../../../Context/AuthContext";

const fetchAdminPayouts = async ({ token, page, status }) => {
  const response = await axios.get(`${process.env.REACT_APP_SERVER_URL}/order/payouts`, {
    headers: { Authorization: `Bearer ${token}` },
    params: { page, status: status === "all" ? undefined : status },
  });
  return response.data;
};

export const useAdminPayouts = (page = 1, status = "all") => {
  const { token } = useContext(AuthContext);

  return useQuery(
    ["adminPayouts", page, status],
    () => fetchAdminPayouts({ token, page, status }),
    { enabled: !!token, keepPreviousData: true }
  );
};

export const useUpdateAdminPayout = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  return useMutation(
    async ({ payoutId, status, adminNote }) => {
      const response = await axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/order/payouts/${payoutId}`,
        { status, adminNote },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      return response.data;
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries("adminPayouts");
      },
    }
  );
};

export default useAdminPayouts;
